<template>
  <div class="wizard-body small-9 columns">
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.DESC')"
    />
    <form class="row" @submit.prevent="createChannel()">
      <div class="medium-8 columns">
        <label :class="{ error: $v.channelName.$error }">
          {{ $t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.CHANNEL_NAME.LABEL') }}
          <input
            v-model.trim="channelName"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.CHANNEL_NAME.PLACEHOLDER')
            "
            @blur="$v.channelName.$touch"
          />
          <span v-if="$v.channelName.$error" class="message">{{
              $t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.CHANNEL_NAME.ERROR')
            }}</span>
        </label>
      </div>

      <div class="medium-8 columns">
        <label :class="{ error: $v.domain.$error }">
          {{ $t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.DOMAIN.LABEL') }}
          <input
            v-model.trim="domain"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.DOMAIN.PLACEHOLDER')
            "
            @blur="getWetalkieData"
          />
          <span v-if="$v.domain.$error" class="message">{{
              $t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.DOMAIN.ERROR')
            }}</span>
        </label>
      </div>

      <div class="medium-8 columns">
        <label :class="{ error: $v.username.$error }">
          {{ $t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.USERNAME.LABEL') }}
          <input
            v-model.trim="username"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.USERNAME.PLACEHOLDER')
            "
            @blur="getWetalkieData"
          />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.USERNAME.SUBTITLE') }}
        </p>
      </div>

      <div class="medium-8 columns">
        <label :class="{ error: $v.password.$error }">
          {{ $t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.PASSWORD.LABEL') }}
          <input
            v-model.trim="password"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.PASSWORD.PLACEHOLDER')
            "
            @blur="getWetalkieData"
          />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.PASSWORD.SUBTITLE') }}
        </p>
      </div>

      <div class="columns medium-12">
        <button class="header-section back-button" @click.prevent="showCustomFilters = !showCustomFilters">
          Adicionar filtros
          <div class="chevron-icon__wrap">
            <fluent-icon v-if="showCustomFilters" icon="chevron-up" />
            <fluent-icon v-else icon="chevron-down" />
          </div>
        </button>
      </div>

      <div v-if="showCustomFilters" class="columns medium-12">
        <div class="medium-8 columns">
          <label>
            Tabulações
            <multiselect
              v-model="tabulations"
              selectedLabel="Selecionado"
              placeholder="Selecionar tabulações"
              label="name"
              track-by="id"
              :max-height="160"
              :option-height="104"
              :multiple="true"
              :allow-empty="true"
              :options="tabulationOptions"
              :loading="wetalkieLoadingTabulations"
              :disabled="!showTabulation"
              :searchable="true"
            >
              <span slot="noOptions">Nenhuma tabulação encontrada</span>
            </multiselect>
          </label>
          <p class="help-text">
            Considerar armazenar apenas conversas dessas tabulações. Deixe vazio caso queira armazenar todos.
          </p>
        </div>

        <div class="medium-8 columns">
          <label>
            Usuários
            <multiselect
              v-model="users"
              selectedLabel="Selecionado"
              placeholder="Selecionar usuários"
              label="personName"
              track-by="id"
              :max-height="160"
              :option-height="104"
              :multiple="true"
              :allow-empty="true"
              :options="userOptions"
              :loading="wetalkieLoadingUsers"
              :disabled="!showUsers"
              :searchable="true"
            >
              <span slot="noOptions">Nenhum usuário encontrado</span>
            </multiselect>
          </label>
          <p class="help-text">
            Considerar armazenar apenas conversas com esses usuários. Deixe vazio caso queira armazenar todas.
          </p>
        </div>

        <div class="medium-8 columns">
          <label>
            Usuários Ignorados
            <multiselect
              v-model="ignoredUsers"
              selectedLabel="Selecionado"
              placeholder="Selecionar usuários"
              label="personName"
              track-by="id"
              :max-height="160"
              :option-height="104"
              :multiple="true"
              :allow-empty="true"
              :options="userOptions"
              :loading="wetalkieLoadingUsers"
              :disabled="!showUsers"
              :searchable="true"
            >
              <span slot="noOptions">Nenhum usuário encontrado</span>
            </multiselect>
          </label>
          <p class="help-text">
            Considerar armazenar apenas conversas sem esses usuários. Deixe vazio caso queira armazenar todas.
          </p>
        </div>

        <div class="medium-8 columns">
          <label :class="{ error: $v.minMessages.$error }">
            Mínimo de Mensagens
            <input
              v-model.trim="minMessages"
              type="text"
              @blur="$v.minMessages.$touch"
            />
            <span v-if="$v.minMessages.$error" class="message">
              Informe uma quantidade valida
            </span>
          </label>
          <p class="help-text">
            Deve ter essa quantidade mínima de mensagens para poder armazenar as
            conversas.
          </p>
          <label :class="{ error: $v.customerMinMessages.$error }">
            Mínimo de Mensagens do Cliente
            <input
              v-model.trim="customerMinMessages"
              type="text"
              @blur="$v.customerMinMessages.$touch"
            />
            <span v-if="$v.customerMinMessages.$error" class="message">
              Informe uma quantidade valida
            </span>
          </label>
          <p class="help-text">
            Deve ter essa quantidade mínima de mensagens para poder armazenar as
            conversas.
          </p>
          <label :class="{ error: $v.operatorMinMessages.$error }">
            Mínimo de Mensagens do Operador
            <input
              v-model.trim="operatorMinMessages"
              type="text"
              @blur="$v.operatorMinMessages.$touch"
            />
            <span v-if="$v.operatorMinMessages.$error" class="message">
              Informe uma quantidade valida
            </span>
          </label>
          <p class="help-text">
            Deve ter essa quantidade mínima de mensagens para poder armazenar as
            conversas.
          </p>
          <label class="bot-switch">
            Contabilizar mensagens do bot
            <woot-switch v-model="countBotMessages" />
            <p class="help-text">
              Se o filtro aplicado de quantidade mínima de mensagens na conversa
              deve considerar as mensagens do bot
            </p>
          </label>
        </div>
      </div>

      <div class="divider">&nbsp;</div>

      <div class="medium-12 columns">
        <woot-submit-button
          :loading="uiFlags.isCreating"
          :button-text="$t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { required, url, numeric } from 'vuelidate/lib/validators';
import PageHeader from '../../SettingsSubPageHeader';
import alertMixin from 'shared/mixins/alertMixin';
import getUuid from 'widget/helpers/uuid';
import router from "../../../../index";
import { mapGetters } from 'vuex';

export default {
  name: 'Wetalkie',
  components: {
    PageHeader
  },
  mixins: [alertMixin],
  data() {
    return {
      channelName: '',
      domain: '',
      username: '',
      password: '',
      tabulations: [],
      tabulationOptions: [],
      ignoredUsers: [],
      users: [],
      userOptions: [],
      minMessages: 10,
      customerMinMessages: 5,
      operatorMinMessages: 5,
      countBotMessages: false,
      showCustomFilters: false,
      showTabulation: false,
      showUsers: false,
      wetalkieLoadingTabulations: false,
      wetalkieLoadingUsers: false,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  watch: {
    showCustomFilters() {
      if (!this.showCustomFilters) this.cleanFilters();
    }
  },
  validations: {
    channelName: { required },
    domain: { required, url },
    username: { required },
    password: { required },
    minMessages: { numeric },
    customerMinMessages: { numeric },
    operatorMinMessages: { numeric },
  },
  methods: {
    getWetalkieData() {
      this.getTabulationsWetalkie();
      this.getUsersWetalkie();
    },
    async getTabulationsWetalkie() {
      this.$v.domain.$touch();

      if (this.username && this.password && this.domain) {
        try {
          this.wetalkieLoadingTabulations = true;
          const response = await this.$store.dispatch(
            'inboxes/getWetalkieTabulations',
            {
              domain: this.domain,
              username: this.username,
              password: this.password,
            }
          );

          if (response) {
            this.tabulationOptions = response.data.items;
            this.showTabulation = true;
          }
        } catch (error) {
          this.showAlert(
            this.$t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.API.ERROR_MESSAGE')
          );
        }
      }

        this.wetalkieLoadingTabulations = false;
    },
    async getUsersWetalkie() {
      this.$v.domain.$touch();

      if (this.username && this.password && this.domain) {
        try {
          this.wetalkieLoadingUsers = true;
         
          const response = await this.$store.dispatch(
            'inboxes/getWetalkieUsers',
            {
              domain: this.domain,
              username: this.username,
              password: this.password,
            }
          );
          if (response) {
            this.userOptions = response.data.items;
            this.showUsers = true;
          }
        } catch (error) {
          this.showAlert(
            this.$t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.API.ERROR_MESSAGE')
          );
        }
      } 

      this.wetalkieLoadingUsers = false;
    },
    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        const wetalkieChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.channelName,
            channel: {
              type: 'wetalkie',
              identifier: getUuid(),
              domain: this.domain,
              username: this.username,
              password: this.password,
              custom_config: {
                tabulations: this.tabulations,
                users: this.users,
                ignored_users: this.ignoredUsers,
                min_messages: parseInt(this.minMessages),
                customer_min_messages: parseInt(this.customerMinMessages),
                operator_min_messages: parseInt(this.operatorMinMessages),
                count_bot_messages: this.countBotMessages,
              },
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: wetalkieChannel.id,
          },
        });
      } catch (error) {
        this.showAlert(
          this.$t('INBOX_MGMT.ADD.WETALKIE_CHANNEL.API.ERROR_MESSAGE')
        );
      }
    },
    cleanFilters() {
      this.minMessages = 10;
      this.customerMinMessages = 5;
      this.operatorMinMessages = 5;
    },
  },
};
</script>

<style lang="scss" scoped>
.wizard-body {
  .divider {
    background: #b8b9bb;
    height: 1px;
    margin: 1.5rem 0;
    flex: 0 0 100%;
  }

  .bot-switch {
    .help-text {
      margin-top: 2px;
    }
  }
}
</style>
